import React from 'react';
import styles from './faq.module.scss';
import FAQModel from '../../models/faq';
import Accordion from '../global/accordion/Accordion';
import Richtext from '../global/richtext/Richtext';

type Props = {
  data: FAQModel;
};

const FAQ = ({ data }: Props) => {
  if (!data) return <></>;
  const { items, icon: parentIcon, textColor: parentTextColor, title } = data;
  const hasItems = items.length > 0;

  const getAccordionConfig = (accordionItem: any) => {
    const {
      icon,
      closedColor,
      openedColor,
      openedBackgroundColor,
      analyticsAttributes
    } = accordionItem;
    // Allows for component level overrides
    return {
      openedColor: openedColor || parentTextColor,
      closedColor: closedColor || parentTextColor,
      icon: icon || parentIcon,
      openedBackgroundColor: openedBackgroundColor || '',
      analyticsAttributes: analyticsAttributes || ''
    };
  };

  return (
    <section
      className={styles.faq}
      style={{
        color: data.textColor
      }}
    >
      <h1 className={styles.faq__title}>{title}</h1>
      {hasItems &&
        items.map((item: any): any => {
          return (
            <Accordion
              customClass={styles.faq__item}
              key={item.internalName}
              title={item.internalName}
              includeHR
              config={getAccordionConfig(item)}
            >
              <Richtext
                data={item.richText}
                customClasses={{
                  container: styles['faq__item-content'],
                  header: styles['faq__item-header']
                }}
              />
            </Accordion>
          );
        })}
    </section>
  );
};

export default FAQ;
